import { useContactsListStore } from '../../../ContactsList.store';
import { BrokerContactCardV2 } from '../../../../Search/BrokerContactCardV2/BrokerContactCardV2';
import { EmployerContactCardV2 } from '../../../../Search/EmployerContactCardV2/EmployerContactCardV2';

export const LoaderRow = () => {
	const { tab } = useContactsListStore();

	return tab === 'broker' ? <BrokerContactCardV2 variant="search" loading={true} /> : <EmployerContactCardV2 variant="search" loading={true} />;
};
